// Per-dog groomer contact cards (multiple). Powered by the reusable
// ContactCardsSection.
import ContactCardsSection from "@/components/app/ContactCardsSection";
import { Scissors } from "lucide-react";

const FIELDS = [
  { key: "name",     label: "Name",              placeholder: "e.g. Bobbie at K9 Cuts", maxLength: 80 },
  { key: "business", label: "Salon / business",  placeholder: "K9 Cuts on Elm St." },
  { key: "phone",    label: "Phone",             placeholder: "555-1234" },
  { key: "email",    label: "Email",             placeholder: "bobbie@k9cuts.com", type: "email" },
  { key: "schedule", label: "Schedule",          placeholder: "Every 4 weeks — Tues 10am", wide: true },
  { key: "notes",    label: "Notes",             placeholder: "Preferred trim, blade lengths, quirks…", type: "textarea", wide: true },
];

export default function GroomersCard({ dogId }) {
  return (
    <ContactCardsSection
      dogId={dogId}
      path="groomers"
      singular="groomer"
      plural="groomers"
      Icon={Scissors}
      overline="Care team"
      title="Groomers"
      intro="Add every groomer or specialist you use — primary, mobile, de-shed pro, whoever."
      fields={FIELDS}
      testidPrefix="groomer"
    />
  );
}
